import profileApiDefinition from './api/index.js'
import profileLifecyclePluginDefinition from './plugin/index.js'
import { fusionProfileAtomDefinition, localProfileAtomDefinition } from './atoms/index.js'
import { DEFAULT_NAME } from './constants.js'

const profile = ({ defaultName = DEFAULT_NAME } = Object.create(null)) => ({
  id: 'profile',
  definitions: [
    { definition: fusionProfileAtomDefinition },
    {
      definition: localProfileAtomDefinition,
      storage: { namespace: 'profile' },
      aliases: [{ implementationId: 'unsafeStorage', interfaceId: 'storage' }],
      config: {
        defaultName,
      },
    },
    {
      definition: profileApiDefinition,
    },
    {
      definition: profileLifecyclePluginDefinition,
    },
  ],
})

export default profile
